import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import { RULER_HEIGHT, ROW_GAP } from '@src/constants/timeline';

export const StyledTimeline = styled.div`
  width: 100%;
  background: ${COLOR.white};
`;

export const StyledBody = styled.div`
  position: relative;
  width: 100%;
`;

// Full-width ruler rules (top + bottom of the ruler row), spanning gutter +
// lanes edge-to-edge, independent of the scrollable content width.
export const StyledRulerLine = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  height: 0;
  border-top: 0.5px solid ${COLOR.indigo[16]};
  pointer-events: none;
  z-index: 1;
  top: ${({ position }) => (position === 'bottom' ? `${RULER_HEIGHT}px` : '0')};
`;

export const StyledGutterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${ROW_GAP}px;
`;

export const StyledGutterSpacer = styled.div`
  height: ${RULER_HEIGHT}px;
`;

export const StyledScrollColumn = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${ROW_GAP}px;
`;
